import '@/utils/capturePasswordLink'
import { registerPlugins } from '@core/utils/plugins'
import { registerViteDevRecovery } from '@core/utils/viteDevRecovery'
import { createApp } from 'vue'
import { createLogger, initVxLog } from '@/@vxapp/@core/Logger/VxLog'
import App from '@/App.vue'
import { disposeNativeApp, initializeNativeApp } from '@/native/nativeApp'
import {
  disposeNativePushRegistration,
  initializeNativePushRegistration,
} from '@/native/nativePushRegistration'
import { router } from '@/plugins/2.router'

initVxLog()

const vueWarnLogger = createLogger('VueWarn')

// Suppress Suspense experimental warnings at console level (before app creation)
if (typeof console !== 'undefined') {
  const shouldSuppressKnownConsoleMessage = args => {
    const message = args[0]

    return (
      typeof message === 'string' &&
      ((message.includes('<Suspense>') && message.includes('experimental')) ||
        message.includes('=== Products Store Not Yet Initialized ==='))
    )
  }

  const originalWarn = console.warn
  const originalInfo = console.info

  console.warn = function (...args) {
    if (shouldSuppressKnownConsoleMessage(args)) {
      return
    }

    originalWarn.apply(console, args)
  }

  console.info = function (...args) {
    if (shouldSuppressKnownConsoleMessage(args)) {
      return
    }

    originalInfo.apply(console, args)
  }
}
// Styles
import '@core/scss/template/index.scss'
import '@core/scss/custom/index.scss'
import '@styles/styles.scss'
import '@styles/native.css'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'

registerViteDevRecovery({
  hot: import.meta.hot,
  eventTarget: window,
  reload: () => window.location.reload(),
})

// Create vue app
const app = createApp(App)

app.config.warnHandler = (message, _instance, trace) => {
  if (message.includes('<Suspense>') && message.includes('experimental feature')) {
    return
  }

  vueWarnLogger.warn(`[Vue warn]: ${message}`, trace)
}

// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')

initializeNativePushRegistration()
void initializeNativeApp(router)

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    disposeNativePushRegistration()
    void disposeNativeApp()
  })
}
